import { wardrobeItem } from '@/Interfaces/common';

export const perforatedPanels = [
    {
        name: 'gp_45_40',
        height: 0.4,
        width: 0.45,
        depth: 0.05,
    } as wardrobeItem,
    {
        name: 'gp_60_40',
        height: 0.4,
        width: 0.6,
        depth: 0.05,
    } as wardrobeItem,
];

export const defaultPerforatedPanelsOffsets = [ 0,0,-0.006 ] as const;
